exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{font-family:'Open Sans', sans-serif;color:#333333;overflow-wrap:break-word}img{width:100%}*{box-sizing:border-box}p{letter-spacing:0.25;line-height:1.5}ul{line-height:1.6}sup{vertical-align:top;font-size:0.6em}\n", ""]);
